@if (earningsAndDeductionsForm != null) {
  <div class="tab-wrapper">
    <form [formGroup]="earningsAndDeductionsForm">
      <div class="card" *ngIf="authService.canRead('employee_earnings_panel')">
        <div class="card-body">
          <div class="float-end">
            <button
              cpGTagEvent
              [params]="{ event_label: 'people_edit_add_earnings' }"
              appAutoFocus
              type="button"
              class="btn btn-primary"
              (click)="openEarnings(earningModal)"
              [disabled]="(readOnly | async) || (getAvailableEarnings | async).length == 0">
              <i class="fas fa-xs fa-plus"></i>&nbsp;Add Earning
            </button>
          </div>
          <h3 class="card-title">Earnings</h3>
          <div *ngIf="(getDisplayedEarnings | async).length == 0">
            <br />
            <em>No Earnings</em>
          </div>
          <table
            *ngIf="(getDisplayedEarnings | async).length > 0"
            class="table table-hover expand-rows">
            <thead>
              <tr>
                <th></th>
                <th>Amount/Rate</th>
                <th>Effective Date</th>
                <th>Change Date</th>
                <th>Changed By</th>
                <th style="width: 100px"></th>
              </tr>
            </thead>
            <tbody *ngFor="let earning of getDisplayedEarnings | async; let i = index">
              <!-- when collapsed, show current effective date first -->
              <!-- when expanded, show future effective date first (if exists)-->

              <!-- if there is no more than 1 rate, show that without any expand/collapse controls -->
              <tr *ngIf="earning.Rates.length <= 1">
                <td>
                  <strong style="padding-left: 30px">{{
                    getEarningName(earning.Id) | async
                  }}</strong>
                  <span *ngIf="(canEarningHaveRates(earning.Id) | async) && !(readOnly | async)">
                    <br />
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_add_earning_rate' }"
                      style="padding-left: 30px"
                      class="btn btn-link"
                      (click)="addEarningRate(earning, earningModal)">
                      <small>Add Rate</small>
                    </button>
                  </span>
                </td>
                <td>
                  <span
                    *ngIf="
                      (canEarningHaveRates(earning.Id) | async) &&
                      earning.Rates &&
                      earning.Rates.length > 0
                    ">
                    {{ getEarningAmountPrefix(earning.Id) | async }}
                    {{ getCurrentEarningRate(earning, true)?.Amount | number: '1.2-4' }}
                    {{ getEarningAmountSuffix(earning.Id) | async }}
                  </span>
                </td>
                <td>
                  {{ getCurrentEarningRate(earning, true)?.EffectiveDate | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentEarningRate(earning, true)?.LastChangedOn | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentEarningRate(earning, true)?.LastEditorId }}
                </td>
                <td class="align-right">
                  <button
                    cpGTagEvent
                    [params]="{ event_label: 'people_edit_edit_earning_rate' }"
                    class="btn btn-link"
                    (click)="
                      editEarning(earning, getCurrentEarningRate(earning, true), earningModal)
                    ">
                    {{ (readOnly | async) ? 'View' : 'Edit' }}
                  </button>
                </td>
              </tr>
              <!-- if there is more than 1 rate & earning is expanded & future rate exists-->
              <!-- show future rate first in list followed by current & past -->
              <tr
                *ngIf="
                  earning.Rates.length > 1 &&
                  isEarningRateExpanded(i) &&
                  getFutureEarningRate(earning) !== null
                ">
                <td>
                  <span
                    (click)="collapseEarnings(i)"
                    [className]="
                      !isEarningRateExpanded(i) ? 'collapse-icon' : 'collapse-icon open'
                    "></span>
                  <strong (click)="collapseEarnings(i)">{{
                    getEarningName(earning.Id) | async
                  }}</strong>
                  <span *ngIf="(canEarningHaveRates(earning.Id) | async) && !(readOnly | async)">
                    <br />
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_add_earning_rate' }"
                      style="padding-left: 30px"
                      class="btn btn-link"
                      (click)="addEarningRate(earning, earningModal)">
                      <small>Add Rate</small>
                    </button>
                  </span>
                </td>
                <td>
                  <span *ngIf="canEarningHaveRates(earning.Id) | async">
                    {{ getEarningAmountPrefix(earning.Id) | async }}
                    {{ getFutureEarningRate(earning).Amount | number: '1.2-4' }}
                    {{ getEarningAmountSuffix(earning.Id) | async }}
                  </span>
                </td>
                <td>{{ getFutureEarningRate(earning).EffectiveDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ getFutureEarningRate(earning).LastChangedOn | date: 'MM/dd/yyyy' }}</td>
                <td>{{ getFutureEarningRate(earning).LastEditorId }}</td>
                <td class="align-right">
                  <button
                    cpGTagEvent
                    [params]="{ event_label: 'people_edit_edit_future_earning_rate' }"
                    class="btn btn-link"
                    (click)="editEarning(earning, getFutureEarningRate(earning), earningModal)">
                    {{ (readOnly | async) ? 'View' : 'Edit' }}
                  </button>
                </td>
              </tr>
              <tr
                *ngIf="
                  earning.Rates.length > 1 &&
                  isEarningRateExpanded(i) &&
                  getFutureEarningRate(earning) !== null
                "
                class="sub-row"
                [ngbCollapse]="!isEarningRateExpanded(i)">
                <td></td>
                <td>
                  <span *ngIf="canEarningHaveRates(earning.Id) | async">
                    {{ getEarningAmountPrefix(earning.Id) | async }}
                    {{ getCurrentEarningRate(earning)?.Amount | number: '1.2-4' }}
                    {{ getEarningAmountSuffix(earning.Id) | async }}
                  </span>
                </td>
                <td>
                  {{ getCurrentEarningRate(earning)?.EffectiveDate | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentEarningRate(earning)?.LastChangedOn | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentEarningRate(earning)?.LastEditorId }}
                </td>
                <td class="align-right">
                  <button
                    class="btn btn-link"
                    cpGTagEvent
                    [params]="{ event_label: 'people_edit_add_future_earning_rate' }"
                    (click)="editEarning(earning, getCurrentEarningRate(earning), earningModal)">
                    {{ (readOnly | async) ? 'View' : 'Edit' }}
                  </button>
                </td>
              </tr>
              <!-- if there is more than 1 rate & (future rate is null OR earning is collapsed)-->
              <!-- show current rate as first item in list -->
              <tr
                *ngIf="
                  earning.Rates.length > 1 &&
                  (getFutureEarningRate(earning) === null || !isEarningRateExpanded(i))
                ">
                <td>
                  <span
                    (click)="collapseEarnings(i)"
                    [className]="
                      !isEarningRateExpanded(i) ? 'collapse-icon' : 'collapse-icon open'
                    "></span>
                  <strong (click)="collapseEarnings(i)">{{
                    getEarningName(earning.Id) | async
                  }}</strong>
                  <span *ngIf="(canEarningHaveRates(earning.Id) | async) && !(readOnly | async)">
                    <br />
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_add_current_earning_rate' }"
                      style="padding-left: 30px"
                      class="btn btn-link"
                      (click)="addEarningRate(earning, earningModal)">
                      <small>Add Rate</small>
                    </button>
                  </span>
                  <br />
                </td>
                <td>
                  <span *ngIf="canEarningHaveRates(earning.Id) | async">
                    {{ getEarningAmountPrefix(earning.Id) | async }}
                    {{ getCurrentEarningRate(earning, true)?.Amount | number: '1.2-4' }}
                    {{ getEarningAmountSuffix(earning.Id) | async }}
                  </span>
                </td>
                <td>
                  {{ getCurrentEarningRate(earning, true)?.EffectiveDate | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentEarningRate(earning, true)?.LastChangedOn | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentEarningRate(earning, true)?.LastEditorId }}
                </td>
                <td class="align-right">
                  <button
                    class="btn btn-link"
                    cpGTagEvent
                    [params]="{ event_label: 'people_edit_edit_current_earning_rate' }"
                    (click)="
                      editEarning(earning, getCurrentEarningRate(earning, true), earningModal)
                    ">
                    {{ (readOnly | async) ? 'View' : 'Edit' }}
                  </button>
                </td>
              </tr>
              <!-- past earnings -->
              <tr
                class="sub-row"
                *ngFor="let rate of getPastEarningRates(earning)"
                [ngbCollapse]="!isEarningRateExpanded(i)">
                <td></td>
                <td>
                  <span *ngIf="canEarningHaveRates(earning.Id) | async">
                    {{ getEarningAmountPrefix(earning.Id) | async }}
                    {{ rate.Amount | number: '1.2-4' }}
                    {{ getEarningAmountSuffix(earning.Id) | async }}
                  </span>
                </td>
                <td>{{ rate.EffectiveDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ rate.LastChangedOn | date: 'MM/dd/yyyy' }}</td>
                <td>{{ rate.LastEditorId }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card" *ngIf="authService.canRead('employee_deductions_panel')">
        <div class="card-body">
          <div class="float-end">
            <button
              cpGTagEvent
              [params]="{ event_label: 'people_edit_add_deduction' }"
              type="button"
              class="btn btn-primary"
              (click)="openDeductions(deductionModal)"
              [disabled]="(getAvailableDeductions | async).length === 0 || (readOnly | async)">
              <i class="fas fa-xs fa-plus"></i>&nbsp;Add Deduction
            </button>
          </div>
          <h3 class="card-title">Deductions</h3>
          <div *ngIf="(getDisplayedDeductions | async).length == 0">
            <br />
            <em>No Deductions</em>
          </div>
          <table
            *ngIf="(getDisplayedDeductions | async).length > 0"
            class="table table-hover expand-rows">
            <thead>
              <tr>
                <th></th>
                <th>Rate/Amount</th>
                <th>Effective Date</th>
                <th>Change Date</th>
                <th>Changed By</th>
                <th style="width: 100px"></th>
              </tr>
            </thead>
            <tbody *ngFor="let deduction of getDisplayedDeductions | async; let i = index">
              <!-- when collapsed, show current effective date first -->
              <!-- when expanded, show future effective date first (if exists)-->

              <!-- if there is only 1 rate, show that without any expand/collapse controls -->
              <!-- also show non-rate deductions -->
              <tr
                *ngIf="!deduction.Rates || !deduction.Rates.length || deduction.Rates.length == 1">
                <td>
                  <strong style="padding-left: 30px">{{
                    getDeductionName(deduction.Id) | async
                  }}</strong>
                  <span
                    *ngIf="
                      getFutureDeductionRate(deduction) === null &&
                      (canDeductionHaveRates(deduction.Id) | async) &&
                      !(readOnly | async)
                    ">
                    <br />
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_add_future_deduction_rate' }"
                      style="padding-left: 30px"
                      class="btn btn-link"
                      (click)="addDeductionRate(deduction, deductionModal)">
                      <small>Add Rate</small>
                    </button>
                  </span>
                </td>
                <td>
                  <span *ngIf="getCurrentDeductionRate(deduction, true)?.Amount">
                    {{ getDeductionAmountPrefix(deduction.Id) | async }}
                    {{ getCurrentDeductionRate(deduction, true)?.Amount | number: '1.2-2' }}
                    {{ getDeductionAmountSuffix(deduction.Id) | async }}
                  </span>
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction, true)?.EffectiveDate | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction, true)?.LastChangedOn | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction, true)?.LastEditorId }}
                </td>
                <td class="align-right">
                  <div>
                    <button
                      class="btn btn-link"
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_deduction' }"
                      (click)="
                        editDeduction(
                          deduction,
                          getCurrentDeductionRate(deduction, true),
                          deductionModal
                        )
                      ">
                      {{ (readOnly | async) ? 'View' : 'Edit' }}
                    </button>
                  </div>
                </td>
              </tr>
              <!-- if there is more than 1 rate & deduction is expanded & future rate exists-->
              <!-- show future rate first in list followed by current & past -->
              <tr
                *ngIf="
                  deduction.Rates.length > 1 &&
                  isDeductionRateExpanded(i) &&
                  getFutureDeductionRate(deduction) !== null
                ">
                <td (click)="collapseDeductions(i)">
                  <span
                    [className]="
                      !isDeductionRateExpanded(i) ? 'collapse-icon' : 'collapse-icon open'
                    ">
                  </span>
                  <strong>{{ getDeductionName(deduction.Id) | async }}</strong>
                  <br />
                </td>
                <td>
                  <span>
                    {{ getDeductionAmountPrefix(deduction.Id) | async }}
                    {{ getFutureDeductionRate(deduction).Amount | number: '1.2-2' }}
                    {{ getDeductionAmountSuffix(deduction.Id) | async }}
                  </span>
                </td>
                <td>{{ getFutureDeductionRate(deduction).EffectiveDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ getFutureDeductionRate(deduction).LastChangedOn | date: 'MM/dd/yyyy' }}</td>
                <td>{{ getFutureDeductionRate(deduction).LastEditorId }}</td>
                <td class="align-right">
                  <button
                    cpGTagEvent
                    [params]="{ event_label: 'people_edit_edit_future_deduction_rate' }"
                    class="btn btn-link"
                    (click)="
                      editDeduction(deduction, getFutureDeductionRate(deduction), deductionModal)
                    ">
                    {{ (readOnly | async) ? 'View' : 'Edit' }}
                  </button>
                </td>
              </tr>
              <tr
                *ngIf="
                  deduction.Rates.length > 1 &&
                  isDeductionRateExpanded(i) &&
                  getFutureDeductionRate(deduction) !== null
                "
                class="sub-row"
                [ngbCollapse]="!isDeductionRateExpanded(i)">
                <td></td>
                <td>
                  <span>
                    {{ getDeductionAmountPrefix(deduction.Id) | async }}
                    {{ getCurrentDeductionRate(deduction)?.Amount | number: '1.2-2' }}
                    {{ getDeductionAmountSuffix(deduction.Id) | async }}
                  </span>
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction)?.EffectiveDate | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction)?.LastChangedOn | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction)?.LastEditorId }}
                </td>
                <td class="align-right">
                  <button
                    class="btn btn-link"
                    cpGTagEvent
                    [params]="{ event_label: 'people_edit_edit_current_deduction_rate' }"
                    (click)="
                      editDeduction(deduction, getCurrentDeductionRate(deduction), deductionModal)
                    ">
                    {{ (readOnly | async) ? 'View' : 'Edit' }}
                  </button>
                </td>
              </tr>
              <!-- if there is more than 1 rate & (future rate is null OR deduction is collapsed)-->
              <!-- show current rate as first item in list -->
              <tr
                *ngIf="
                  deduction.Rates.length > 1 &&
                  (getFutureDeductionRate(deduction) === null || !isDeductionRateExpanded(i))
                ">
                <td>
                  <span
                    (click)="collapseDeductions(i)"
                    [className]="
                      !isDeductionRateExpanded(i) ? 'collapse-icon' : 'collapse-icon open'
                    "
                    [ngStyle]="{
                      visibility: canDeductionHaveRates(deduction.Id) ? 'visible' : 'hidden'
                    }">
                  </span>
                  <strong (click)="collapseDeductions(i)">{{
                    getDeductionName(deduction.Id) | async
                  }}</strong>
                  <span
                    *ngIf="
                      getFutureDeductionRate(deduction) === null &&
                      canDeductionHaveRates(deduction.Id) &&
                      !(readOnly | async)
                    ">
                    <br />
                    <button
                      style="padding-left: 30px"
                      class="btn btn-link"
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_add_deduction_rate' }"
                      (click)="addDeductionRate(deduction, deductionModal)">
                      <small>Add Rate</small>
                    </button>
                  </span>
                  <br />
                </td>
                <td>
                  <span>
                    {{ getDeductionAmountPrefix(deduction.Id) | async }}
                    {{ getCurrentDeductionRate(deduction, true)?.Amount | number: '1.2-2' }}
                    {{ getDeductionAmountSuffix(deduction.Id) | async }}
                  </span>
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction, true)?.EffectiveDate | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction, true)?.LastChangedOn | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                  {{ getCurrentDeductionRate(deduction, true)?.LastEditorId }}
                </td>
                <td class="align-right">
                  <div>
                    <button
                      class="btn btn-link"
                      cpGTagEvent
                      [params]="{ event_label: 'people_edit_edit_deduction_rate' }"
                      (click)="
                        editDeduction(
                          deduction,
                          getCurrentDeductionRate(deduction, true),
                          deductionModal
                        )
                      ">
                      {{ (readOnly | async) ? 'View' : 'Edit' }}
                    </button>
                  </div>
                </td>
              </tr>
              <!-- past deductions -->
              <tr
                class="sub-row"
                *ngFor="let rate of getPastDeductionRates(deduction)"
                [ngbCollapse]="!isDeductionRateExpanded(i)">
                <td></td>
                <td>
                  <span>
                    {{ getDeductionAmountPrefix(deduction.Id) | async }}
                    {{ rate.Amount | number: '1.2-2' }}
                    {{ getDeductionAmountSuffix(deduction.Id) | async }}
                  </span>
                </td>
                <td>{{ rate.EffectiveDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ rate.LastChangedOn | date: 'MM/dd/yyyy' }}</td>
                <td>{{ rate.LastEditorId }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
  <ng-template #earningModal let-modal>
    <form
      [formGroup]="earningsModalForm"
      class="padded-form"
      [ngClass]="{ readOnly: (readOnly | async) }">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ selEarningName }} Earning</h4>
        <button
          cpGTagEvent
          [params]="{ event_label: 'people_edit_earning_modal_dismiss' }"
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" *hasPermission="'employee_earnings_earning_id'">
          <div class="col-lg-12" *ngIf="selEarningName === null">
            <label>Select an Earning</label>
            <select
              appAutoFocus
              formControlName="EarningId"
              class="form-control"
              (change)="onEarningTypeChange()">
              <option></option>
              <option *ngFor="let config of getAvailableEarnings | async" value="{{ config.Id }}">
                {{ config.Name }}
              </option>
            </select>
            <div *ngIf="e.EarningId.errors?.required" class="input-error">*required</div>
          </div>
        </div>
        <div *ngIf="canEarningHaveRates(e.EarningId.value) | async" class="row">
          <div class="col-lg-6">
            <div *hasPermission="'employee_earnings_amount'">
              <label>{{ getEarningName(e.EarningId.value) | async }} Amount</label>
              <div class="input-group">
                <input
                  appNumberInput
                  formControlName="Amount"
                  [attr.disabled]="e.Amount.disabled ? 'disabled' : null"
                  class="form-control"
                  [decimals]="(getEarningCalc(e.EarningId.value) | async) == 1 ? 4 : 2"
                  (ngModelChange)="isEarningModalEmpty()" />
                <div
                  class="input-group-prepend"
                  *ngIf="(getEarningAmountPrefix(e.EarningId.value) | async) === '$'">
                  <span class="input-group-text">$</span>
                </div>
                <div
                  class="input-group-append"
                  *ngIf="(getEarningAmountSuffix(e.EarningId.value) | async) === '%'">
                  <span class="input-group-text">%</span>
                </div>
                <div *ngIf="e.Amount.errors?.required" class="input-error input-group-error">
                  *required
                </div>
                <div *ngIf="e.Amount.errors?.max" class="input-error input-group-error">
                  *{{ e.Amount.value | number: '1.2-4' }} exceeds maxium allowed of
                  <span *ngIf="(getEarningAmountPrefix(e.EarningId.value) | async) === '$'"
                    >$9,999,999.9999</span
                  >
                  <span *ngIf="(getEarningAmountSuffix(e.EarningId.value) | async) === '%'"
                    >100.00%</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div *hasPermission="'employee_earnings_effective_date'">
              <label>Effective Date</label>
              <br />
              <div class="input-group">
                <input
                  formControlName="Date"
                  class="form-control datepicker"
                  ngbDatepicker
                  [placement]="['bottom-end', 'top-end']"
                  #eadatepicker="ngbDatepicker"
                  [firstDayOfWeek]="7"
                  [maxDate]="eMaxDate"
                  (ngModelChange)="checkEarningEffectiveDate(e.EarningId.value)" />
                <div
                  *ngIf="e.Date.touched && isDateBeforeToday(e.Date.value) && !customEarningError"
                  class="input-error input-group-error">
                  *Rate effective before today is being added
                </div>
                <div *ngIf="e.Date.errors?.required" class="input-error input-group-error">
                  *required
                </div>
                <div
                  *ngIf="!e.Date.valid && !e.Date.errors?.required"
                  class="input-error input-group-error">
                  *invalid date
                </div>
                <div *ngIf="customEarningError" class="input-error input-group-error">
                  {{ customEarningError }}
                </div>
                <img
                  src="assets/icons/calendar.svg"
                  (click)="eadatepicker.toggle()"
                  class="icon-append" />
              </div>
            </div>
          </div>
        </div>
        <div class="row" *hasPermission="'employee_earnings_hours_paid_per_payroll'">
          <div *ngIf="canEarningSetHours(e.EarningId.value)" class="col-lg-12">
            <label>Hours to be paid each payroll</label>
            <input
              formControlName="HoursPaidPerPayroll"
              class="form-control"
              appNumberInput
              (ngModelChange)="isEarningModalEmpty()"
              [attr.disabled]="e.HoursPaidPerPayroll.disabled ? 'disabled' : null" />
            <div
              *ngIf="e.HoursPaidPerPayroll.errors && e.HoursPaidPerPayroll.errors.max"
              class="input-error">
              *Warning: Hours for Earning exceeds {{ autoPayThreshold }}
            </div>
            <div
              *ngIf="e.HoursPaidPerPayroll.errors && !e.HoursPaidPerPayroll.errors.max"
              class="input-error">
              *invalid number
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div *ngIf="e.EarningId.value" style="position: absolute; left: 50px">
          <div *hasPermission="'employee_earnings_disabled'">
            <input
              formControlName="IsDisabled"
              type="checkbox"
              id="checkbox-disabled"
              value="true"
              (change)="onEarningTypeChange()" />
            <label for="checkbox-disabled"
              ><span></span>Disabled<em class="text-muted"> (check for yes)</em></label
            >
          </div>
        </div>
        <button
          cpGTagEvent
          [params]="{ event_label: 'people_edit_earning_modal_cancel' }"
          type="button"
          class="btn btn-secondary"
          (click)="modal.dismiss()">
          Cancel
        </button>
        <!-- see bug 5199 for long discussion on when save earning button should be enabled -->
        <button
          cpGTagEvent
          [params]="{ event_label: 'people_edit_earning_modal_save' }"
          type="button"
          class="btn btn-primary"
          (click)="modal.close()"
          [attr.disabled]="
            (readOnly | async) ||
            !earningsModalForm.valid ||
            customEarningError ||
            (emptyEarningModal && !isEditingEarning)
              ? 'disabled'
              : null
          ">
          Save Earning
        </button>
      </div>
      <div class="text-end pb-2 pe-3" *ngIf="readOnly | async">
        <strong
          ><em>{{ clientLockMsg }}</em></strong
        >
      </div>
    </form>
  </ng-template>
  <ng-template #deductionModal let-modal>
    <form
      [formGroup]="deductionsModalForm"
      class="padded-form"
      [ngClass]="{ readOnly: (readOnly | async) }">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ selDeductionName }} Deduction</h4>
        <button
          cpGTagEvent
          [params]="{ event_label: 'people_edit_deduction_modal_dismiss' }"
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" *hasPermission="'employee_deductions_deduction_id'">
          <div class="col-lg-12" *ngIf="selDeductionName === null">
            <label>Select a Benefit</label>
            <select
              appAutoFocus
              formControlName="DeductionId"
              class="form-control"
              (ngModelChange)="onDeductionChange()">
              <option></option>
              <option *ngFor="let config of getAvailableDeductions | async" value="{{ config.Id }}">
                {{ config.Name }}
              </option>
            </select>
            <div *ngIf="d.DeductionId.errors?.required" class="input-error">*required</div>
          </div>
        </div>
        <div
          class="row"
          *ngIf="
            d.DeductionId.value && (getDeductionConfig(d.DeductionId.value) | async).CanHaveRates
          ">
          <div
            class="col-lg-6"
            *ngIf="d.DeductionId.value && (getBenefitType(d.DeductionId.value) | async) !== 'Loan'">
            <div *hasPermission="'employee_deductions_amount'">
              <label>{{ getDeductionName(d.DeductionId.value) | async }} Amount</label>
              <div class="input-group">
                <input
                  appNumberInput
                  formControlName="Amount"
                  class="form-control"
                  [attr.disabled]="d.Amount.disabled ? 'disabled' : null" />
                <div
                  class="input-group-prepend"
                  *ngIf="(getDeductionAmountPrefix(d.DeductionId.value) | async) === '$'">
                  <span class="input-group-text">$</span>
                </div>
                <div
                  class="input-group-append"
                  *ngIf="(getDeductionAmountSuffix(d.DeductionId.value) | async) === '%'">
                  <span class="input-group-text">%</span>
                </div>
                <div *ngIf="d.Amount.errors?.required" class="input-error input-group-error">
                  *required
                </div>
                <div *ngIf="d.Amount.errors?.max" class="input-error input-group-error">
                  *{{ d.Amount.value | number: '1.2-2' }} exceeds maxium allowed of
                  <span
                    *ngIf="!(getDeductionConfig(d.DeductionId.value) | async).IsPercentageDeduction"
                    >$9,999,999.99</span
                  >
                  <span
                    *ngIf="(getDeductionConfig(d.DeductionId.value) | async).IsPercentageDeduction"
                    >100.00%</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" *ngIf="(getBenefitType(d.DeductionId.value) | async) === 'Loan'">
            <div *hasPermission="'employee_deductions_amount'">
              <label>Loan Amount</label>
              <div class="input-group">
                <input
                  appNumberInput
                  formControlName="Amount"
                  class="form-control"
                  [attr.disabled]="d.Amount.disabled ? 'disabled' : null" />
                <div
                  class="input-group-prepend"
                  *ngIf="(getDeductionAmountPrefix(d.DeductionId.value) | async) === '$'">
                  <span class="input-group-text">$</span>
                </div>
                <div
                  class="input-group-append"
                  *ngIf="(getDeductionAmountSuffix(d.DeductionId.value) | async) === '%'">
                  <span class="input-group-text">%</span>
                </div>
                <div *ngIf="d.Amount.errors?.required" class="input-error input-group-error">
                  *required
                </div>
                <div *ngIf="d.Amount.errors?.max" class="input-error input-group-error">
                  *value too large
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" *ngIf="d.DeductionId.value">
            <div *hasPermission="'employee_deductions_effective_date'">
              <label>Effective Date</label>
              <div class="input-group">
                <input
                  formControlName="Date"
                  class="form-control datepicker"
                  ngbDatepicker
                  [placement]="['bottom-end', 'top-end']"
                  #dedatepicker="ngbDatepicker"
                  [firstDayOfWeek]="7"
                  (change)="checkDeductionEffectiveDate(d.DeductionId.value)" />
                <div
                  *ngIf="d.Date.touched && isDateBeforeToday(d.Date.value) && !customDeductionError"
                  class="input-error input-group-error">
                  *Rate effective before today is being added
                </div>
                <div *ngIf="d.Date.errors?.required" class="input-error input-group-error">
                  *required
                </div>
                <div
                  *ngIf="!d.Date.valid && !d.Date.errors?.required"
                  class="input-error input-group-error">
                  *invalid date
                </div>
                <div *ngIf="customDeductionError" class="input-error input-group-error">
                  {{ customDeductionError }}
                </div>
                <img
                  src="assets/icons/calendar.svg"
                  (click)="dedatepicker.toggle()"
                  class="icon-append" />
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="d.DeductionId.value && (canHaveDisposableLimits(d.DeductionId.value) | async)"
          title="Garnishments can be taken for any type of debt. The amount of pay garnished should be based on an employee's 'disposable earnings' (the amount remaining after legally mandated deductions). Employers are typically notified of a garnishment via a court order or IRS levy. Refer to the wage garnishment and levy paperwork to enter the disposable pay limit rule.">
          <label> Garnishments and Levies </label>
          <div class="card">
            <div class="card-body" style="padding: 1.5rem">
              <div class="row" *hasPermission="'employee_deductions_disposable_limit_type'">
                <div class="col-lg-12">
                  <input
                    type="radio"
                    id="disposable-limit-radio-1"
                    formControlName="DisposableLimitType"
                    name="DisposableLimitType"
                    value="1" />
                  <label for="disposable-limit-radio-1"
                    ><span></span>Per pay garnishment or levy not to exceed</label
                  >
                </div>
                <div class="col-lg-12">
                  <input
                    type="radio"
                    id="disposable-limit-radio-2"
                    formControlName="DisposableLimitType"
                    name="DisposableLimitType"
                    value="2" />
                  <label for="disposable-limit-radio-2"
                    ><span></span>Minimum disposable pay after garnishment or levy is</label
                  >
                </div>
              </div>
              <div class="row" *hasPermission="'employee_deductions_disposable_limit'">
                <div class="col-lg-12">
                  <div class="input-group">
                    <input
                      appNumberInput
                      formControlName="DisposableLimit"
                      class="form-control"
                      [attr.disabled]="d.DisposableLimit.disabled ? 'disabled' : null" />
                    <div class="input-group-prepend" *ngIf="d.DisposableLimitType.value != 1">
                      <span class="input-group-text">$</span>
                    </div>
                    <div class="input-group-append" *ngIf="d.DisposableLimitType.value == 1">
                      <span class="input-group-text">% of disposable pay</span>
                    </div>
                    <div
                      *ngIf="d.DisposableLimit.errors?.required"
                      class="input-error input-group-error">
                      *required
                    </div>
                    <div
                      *ngIf="d.DisposableLimit.errors?.max"
                      class="input-error input-group-error">
                      *invalid number
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          *ngIf="d.DeductionId.value && (canHaveAnnualLimit(d.DeductionId.value) | async)">
          <div class="col-lg-6">
            <div *hasPermission="'employee_deductions_loan_limit'">
              <label *ngIf="(getBenefitType(d.DeductionId.value) | async) === 'Loan'">
                Loan Limit
              </label>
              <label *ngIf="(getBenefitType(d.DeductionId.value) | async) !== 'Loan'">
                Annual Limit
              </label>
              <div class="input-group">
                <input
                  appNumberInput
                  formControlName="AnnualLimit"
                  class="form-control"
                  [attr.disabled]="d.AnnualLimit.disabled ? 'disabled' : null" />
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <div *ngIf="d.AnnualLimit.errors?.required" class="input-error input-group-error">
                  *required
                </div>
                <div *ngIf="d.AnnualLimit.errors?.max" class="input-error input-group-error">
                  *value too large
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" *ngIf="(getBenefitType(d.DeductionId.value) | async) === 'Loan'">
            <div *hasPermission="'employee_deductions_loan_balance'">
              <label>Loan Balance</label><br />
              $ {{ (d.Balance && d.Balance.value ? d.Balance.value : 0) | number: '1.2-2' }}
            </div>
          </div>
          <div class="col-lg-6" *ngIf="(getBenefitType(d.DeductionId.value) | async) === 'Loan'">
            <div *hasPermission="'employee_deductions_loan_id'">
              <label>Loan ID</label>
              <input formControlName="LoanId" class="form-control" />
            </div>
          </div>
        </div>
        <div *ngIf="d.DeductionId.value && (canShowDisbursements(d.DeductionId.value) | async)">
          <label>Third Party Disbursement</label>
          <div class="card">
            <div class="card-body" style="padding: 1.5rem">
              <div class="row" *hasPermission="'employee_deductions_third_party_payee'">
                <div class="col-lg-12">
                  <label>Make Payment to</label>
                  <select
                    formControlName="SelectedThirdPartyPayee"
                    class="form-control"
                    [attr.disabled]="
                      (canEditDisbursements(d.DeductionId.value) | async) ? null : 'disabled'
                    ">
                    <option></option>
                    @for (
                      payee of getThirdPartyPayees(d.DeductionId.value) | async;
                      track payee.Id
                    ) {
                      <option value="{{ payee.Id }}">{{ payee.Value }}</option>
                    }
                  </select>
                  <div *ngIf="d.SelectedThirdPartyPayee.errors" class="input-error">*required</div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_deductions_case_number'">
                <div class="col-lg-12">
                  <label>Case Number</label>
                  <input class="form-control" formControlName="CaseNumber" />
                </div>
              </div>
              <div class="row" *hasPermission="'employee_deductions_employer_offers_med_insurance'">
                <div class="col-lg-12" *ngIf="canOfferMedIns(d.DeductionId.value) | async">
                  <input
                    formControlName="EmployerOffersFamilyMedIns"
                    type="checkbox"
                    id="checkbox-employer-med"
                    value="true" />
                  <label for="checkbox-employer-med"
                    ><span></span>Employer offers family medical insurance</label
                  ><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div *ngIf="d.DeductionId.value" style="position: absolute; left: 50px">
          <div *hasPermission="'employee_deductions_disabled'">
            <input
              formControlName="IsDisabled"
              type="checkbox"
              id="checkbox-disabled"
              value="true"
              (change)="onEarningDisable()" />
            <label for="checkbox-disabled"
              ><span></span>Disabled&nbsp;<em class="text-muted">(check for yes)</em></label
            >
          </div>
        </div>
        <button
          cpGTagEvent
          [params]="{ event_label: 'people_edit_deduction_modal_cancel' }"
          type="button"
          class="btn btn-secondary"
          (click)="modal.dismiss()">
          Cancel
        </button>
        <button
          cpGTagEvent
          [params]="{ event_label: 'people_edit_deduction_modal_save' }"
          type="button"
          class="btn btn-primary"
          (click)="modal.close()"
          [attr.disabled]="
            !deductionsModalForm.valid || customDeductionError || (readOnly | async)
              ? 'disabled'
              : null
          ">
          Save Deduction
        </button>
      </div>
      <div class="text-end pb-2 pe-3" *ngIf="readOnly | async">
        <strong
          ><em>{{ clientLockMsg }}</em></strong
        >
      </div>
    </form>
  </ng-template>
}
